import GalleryItem from '@/components/Gallery/item';
import SampleNextArrow from '@/components/SampleNextArrow';
import SamplePrevArrow from '@/components/SamplePrevArrow';
import { websiteEnv } from '@/constants/website-env';
import useIsMobile from '@/hooks/use-is-mobile';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import Slider from 'react-slick';
import classes from './itemModal.module.css';
import { useItemModal } from './useItemModal';

const ItemModal = props => {
  const { item, open, storeConfig, onClose } = props;

  const isMobile = useIsMobile();

  const { products, colors } = useItemModal({
    item,
  });

  const sliderProps = {
    dots: false,
    infinite: false,
    showArrows: false,
    slidesToShow: isMobile ? 3 : 3,
    arrows: !isMobile,
    nextArrow: isMobile ? null : <SampleNextArrow className={'nextarrow'} />,
    prevArrow: isMobile ? null : <SamplePrevArrow className={'prevarrow'} />,
    slidesToScroll: isMobile ? 1 : 3,
    margin: '10px',
  };
  const router = useRouter();

  const onColorClick = useCallback(color => {
    router.push(color.link);
  }, []);

  const onShopMoreClick = useCallback(() => {
    router.push(item.link);
  }, []);

  const onShopNowClick = useCallback(item => {
    router.push(item.url_key + '.html');
  }, []);

  const onCloseClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const maybeProductList =
    products && storeConfig ? (
      <Slider {...sliderProps}>
        {products.map((item, index) => {
          return (
            <div
              className={classes.itemContainer}
              key={item.id}
            >
              <GalleryItem
                key={item.id}
                item={item}
                showCustomizeOptions={false}
                storeConfig={storeConfig}
                hideMark
                showReview={false}
                classes={{
                  price: 'text-base',
                  name: 'text-base',
                }}
              />
              <div
                className='aw-default-link mt-2.5 cursor-pointer rounded-[3px] text-center text-base uppercase leading-10'
                onClick={() => {
                  onShopNowClick(item);
                }}
              >
                shop now
              </div>
            </div>
          );
        })}
      </Slider>
    ) : null;

  const maybeColorList = colors
    ? colors.map(color => {
        return (
          <a
            className={classes.colorItem}
            onClick={() => {
              onColorClick(color);
            }}
            key={color.rgb}
          >
            <div
              className={classes.colorBlock}
              style={{
                background: color.rgb,
              }}
            />
            <span>{color.label}</span>
          </a>
        );
      })
    : null;

  const rootClass = open ? classes.root_open : classes.root;

  return (
    <div className={rootClass}>
      <div className={classes.mask} />
      <div className={classes.content}>
        <div
          className={classes.closeButton}
          onClick={onCloseClick}
        />
        <img
          className={classes.img}
          src={item.pic}
          alt={item.alt || undefined}
        />
        <div className={classes.itemInfo}>
          <p className={classes.title}>shop the style</p>
          <div className={classes.listContainer}>{maybeProductList}</div>
          {colors && colors.length > 0 && (
            <p className={classes.title}>shop the {websiteEnv.isUnitedKingdom ? 'colour' : 'color'}</p>
          )}
          <div className={classes.colorContainer}>{maybeColorList}</div>
          <p
            className={classes.shopMore}
            onClick={onShopMoreClick}
          >
            Shop more style &gt;
          </p>
          <p className={classes.share}>
            <span>Share With：</span>
            <ul className={classes.sharelist}>
              <li>
                <a
                  href='https://www.facebook.com/aw.bridal/'
                  target='_blank'
                  rel='nofollow'
                />
              </li>
              <li>
                <a
                  href='https://www.pinterest.com/aw_bridal/'
                  target='_blank'
                  rel='nofollow'
                />
              </li>
              <li>
                <a
                  href={
                    'mailto:?subject=AW Bridal Real Wedding!&body=' +
                    globalThis.location.origin +
                    process.env.NEXT_PUBLIC_BASE_PATH +
                    '/real-wedding'
                  }
                  target='_blank'
                  rel='nofollow'
                />
              </li>
              <li>
                <a
                  href={
                    'http://twitter.com/share?url=' +
                    globalThis.location.origin +
                    process.env.NEXT_PUBLIC_BASE_PATH +
                    '/real-wedding'
                  }
                  target='_blank'
                  rel='nofollow'
                />
              </li>
            </ul>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ItemModal;
